import React from 'react';
import { redirectToLogin } from './routeHelper';
import store from '../store';
import { CREATE_ALERT } from '../actions/types';
import { portalMessages } from './portalMessages';
import _, { isEmpty } from 'lodash';

export const handleApiError = (error) => {
    if (error.response && error.response.status === 401) {
        redirectToLogin();
    }
    else {
        //source:
        //https://www.intricatecloud.io/2020/03/how-to-handle-api-errors-in-your-web-app-using-axios/

        if (error.response) {
            //backend returned error
            alertError(portalMessages.UNEXPECTED_ERROR_OCCURED);
        } else if (error.request) {
            //could not reach backend
            alertError(portalMessages.NETWORK_ERROR);
        } else {
            //real unexpexted error
            alertError(portalMessages.UNEXPECTED_ERROR_OCCURED);
        }
    }
}

export const showErrorMessage = message => {
    return (
        <div className="v-red v-font-size">
            <i className="fa fa-exclamation-circle v-red" aria-hidden="true">
                <span className="v-font"> {message}</span>
            </i>
        </div>
    );
}

export const showSuccessMessage = message => {
    return (
        <div className="v-green v-font-size">
            <i className="fa fa-check v-green" aria-hidden="true">
                <span className="v-font"> {message}</span>
            </i>
        </div>
    );
}

const types = { info: 'info', success: 'success', warning: 'warning', danger: 'danger' };

export const alertError = message => {
    store.dispatch({ type: CREATE_ALERT, payload: { type: types.danger, message } });
}

export const alertSuccess = message => {
    store.dispatch({ type: CREATE_ALERT, payload: { type: types.success, message } });
}

export const alertWarning = message => {
    store.dispatch({ type: CREATE_ALERT, payload: { type: types.warning, message } });
}

export const alertInfo = message => {
    store.dispatch({ type: CREATE_ALERT, payload: { type: types.info, message } });
}

export const rearrangeErrors = error => {
    let allErrors = {};

    if (error.multi)
        allErrors = { ...error.multi };

    if (error.default)
        allErrors.default = error.default;

    return allErrors;
}

export const specifyErrorMessage = (error, messagesDict, operationName) => {
    let message, errorType;

    if (!error)
        return null;

    if (!messagesDict || isEmpty(messagesDict))
        return { message: portalMessages.UNEXPECTED_ERROR_OCCURED, errorType: "" };

    if (!_.isObject(error))
        return { message: error, errorType: "" };

    let allErrors = rearrangeErrors(error);

    if (!_.isEmpty(allErrors)) {
        Object.keys(allErrors).forEach(errorKey => {
            const errorDetail = allErrors[errorKey];

            Object.keys(errorDetail).forEach(currentErrorType => {
                message = messagesDict[currentErrorType];
                errorType = currentErrorType;

                if (_.isObject(message)) {
                    message = messagesDict[currentErrorType][errorDetail[currentErrorType]];

                    if (_.isObject(message)) {
                        message = message[operationName] ?? message["Default"];
                    }

                    if (!message)
                        message = messagesDict[currentErrorType]["Default"];
                }
            });
        });
    }

    if (!message)
        return { message: messagesDict["Default"], errorType: "Default" };

    if (!message)
        return { message: portalMessages.UNEXPECTED_ERROR_OCCURED, errorType: "" };

    return { message, errorType };
}